// 用户信息
import {emailLogin, getInfo, logout} from "@/api/login";
import {removeToken, setToken} from "@/utils/auth";
import {getUserInfo, getUserInfoAccount} from "@/api/yuzhen/userInfo";
import {getUserProfile} from "@/api/system/user";

export default {
  // 开启命名空间
  namespaced: true,
  state: {
    userInfo: {
      id: 0, // 用户编号
      name: '',
      avatar: '',
      roles: [],
      mobile: '',
      email: '',
      permissions: [],
      login: false, // 用户是否登录
      grade: '',   // 会员等级
      account: 0, // 账户
      awardAccount: 0, // 赠送金额账户
      meetingLimit: '', // 会议数量限制
      pexipTime: '',  // 会议时长
      pexipDuration: '', //会议已使用时长
      language: '', //语言
      creditRating: null,  //用户信用等级
      limitTime: null,  //用户限制时间
      yuzhenId: ''    // 与真id
    }
  },
  mutations: {
    updateUserInfo(state, val) {
      state.userInfo = val;
    },
    SET_ID: (state, id) => {
      state.userInfo.id = id
    },
    SET_NAME: (state, name) => {
      state.userInfo.name = name
    },
    SET_NICKNAME: (state, nickname) => {
      state.userInfo.nickname = nickname
    },
    SET_MOBILE: (state, mobile) => {
      state.userInfo.mobile = mobile
    },
    SET_EMAIL: (state, email) => {
      state.userInfo.email = email
    },
    SET_AVATAR: (state, avatar) => {
      state.userInfo.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.userInfo.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.userInfo.permissions = permissions
    },
    SET_LOGIN:(state, flag) => {
      state.userInfo.login = flag
    },
    SET_INFO:(state, data) => {
      state.userInfo.grade = data.grade
      state.userInfo.pexipTime = data.pexipTime
      state.userInfo.pexipDuration = data.pexipDuration
      state.userInfo.meetingLimit = data.meetingLimit
      state.userInfo.account = data.account
      state.userInfo.awardAccount = data.awardAccount
      state.userInfo.language = data.language
      state.userInfo.creditRating = data.creditRating
      state.userInfo.limitTime = data.limitTime
      state.userInfo.yuzhenId = data.yuzhenId
    },
    },
  actions: {
    asyncUpdateInfo(store, val) {
      store.commit('updateUserInfo', val)
    },

    // 邮箱登录
    EmailLogin({ commit }, userInfo) {
      const username = userInfo.email.trim()
      const password = userInfo.password
      const captchaVerification = userInfo.captchaVerification
      return new Promise((resolve, reject) => {
        emailLogin(username, password, captchaVerification).then(res => {
          res = res.data;
          // 设置 token
          setToken(res)
          commit('SET_LOGIN', true)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          // commit('SET_ROLES', [])
          // commit('SET_PERMISSIONS', [])
          // commit('SET_LOGIN', false)
          let user =     {
                id: 0, // 用户编号
                name: '',
                avatar: '',
                roles: [],
                mobile: '',
                permissions: [],
                login: false, // 用户是否登录
                grade: '',   // 会员等级
                meetingLimit: '', // 会议数量限制
                pexipTime: '',  // 会议时长
                pexipDuration: '', //会议已使用时长
          }
          commit('updateUserInfo', user)
          removeToken()
          // 删除相关用户信息
          localStorage.setItem(
              'userInfo',
              JSON.stringify({})
          )
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          // 没有 data 数据，赋予个默认值
          if (!res) {
            res = {
              data: {
                roles: [],
                user: {
                  id: '',
                  avatar: '',
                  userName: '',
                  nickname: ''
                }
              }
            }
          }
          // console.log("获取到了用户信息")
          // console.log(res)
          res = res.data; // 读取 data 数据
          const user = res.user
          const avatar = ( user.avatar === "" || user.avatar == null ) ? require("@/assets/images/profile.jpg") : user.avatar;
          if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', res.roles)
            commit('SET_PERMISSIONS', res.permissions)
          } else {
            commit('SET_ROLES', ['ROLE_DEFAULT'])
          }
          commit('SET_ID', user.id)
          commit('SET_NAME', user.userName)
          commit('SET_NICKNAME', user.nickname)

          commit('SET_AVATAR', avatar)

          getUserProfile().then(res => {
            console.log(res.data.email)
            commit('SET_MOBILE', res.data.mobile)
            commit('SET_EMAIL', res.data.email)
          }).catch(err => {
            console.log(err)
            console.log("获取与真信息错误")
          })
          // 获取与真用户信息
          getUserInfo(user.id).then(res => {
            res = res.data; // 读取 data 数据
            commit('SET_INFO', res)
            localStorage.setItem(
                'userInfo',
                JSON.stringify(state.userInfo)
            )
          }).catch(err => {
            console.log(err)
            console.log("获取与真信息错误")
            localStorage.setItem(
                'userInfo',
                JSON.stringify(state.userInfo)
            )
          })
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateInfo({ commit, state }){
      return new Promise((resolve, reject) => {
        // 获取与真用户信息
        getUserInfo(state.userInfo.id).then(res => {
          res = res.data; // 读取 data 数据
          commit('SET_INFO', res)
          localStorage.setItem(
              'userInfo',
              JSON.stringify(state.userInfo)
          )
          resolve(res)
        }).catch(err => {
          localStorage.setItem(
              'userInfo',
              JSON.stringify(state.userInfo)
          )
          reject(err)
        })
      })
    },
  },
  getters: {
    userInfo: state => {
      return state.userInfo;
    }
  }
}
